/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface LogicalElementCharacteristics
 */
export interface LogicalElementCharacteristics {
  /**
   *
   * @type {object}
   * @memberof LogicalElementCharacteristics
   */
  data: object;
}

/**
 * Check if a given object implements the LogicalElementCharacteristics interface.
 */
export function instanceOfLogicalElementCharacteristics(
  value: object
): value is LogicalElementCharacteristics {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function LogicalElementCharacteristicsFromJSON(json: any): LogicalElementCharacteristics {
  return LogicalElementCharacteristicsFromJSONTyped(json, false);
}

export function LogicalElementCharacteristicsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LogicalElementCharacteristics {
  if (json == null) {
    return json;
  }
  return {
    data: json['data']
  };
}

export function LogicalElementCharacteristicsToJSON(
  value?: LogicalElementCharacteristics | null
): any {
  if (value == null) {
    return value;
  }
  return {
    data: value['data']
  };
}
